import * as React from "react";

function SvgDelete(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -9 34 36" width={24.211} height={25.059} {...props}>
        <path
          d="M16.347 0H7.86a2.03 2.03 0 00-1.9 2.135v1.742h-5A1.031 1.031 0 000 4.962a1.03 1.03 0 00.964 1.084h.851v18.877a2.03 2.03 0 001.9 2.135h17.05a2.03 2.03 0 001.9-2.135V6.046h.555a1.055 1.055 0 00.992-1.084 1.145 1.145 0 00-.283-.763.964.964 0 00-.709-.322h-4.973V2.135A2.03 2.03 0 0016.347 0zm-8.49 3.9V2.142h8.482V3.9zM3.715 24.92V6.046h17.047V24.92zM17.291 9.682a1.037 1.037 0 00-.97 1.091V20.89a.976.976 0 101.939 0V10.773a1.037 1.037 0 00-.969-1.091zm-5.2 0a1.037 1.037 0 00-.97 1.091V20.89a1.037 1.037 0 00.97 1.091 1.037 1.037 0 00.97-1.091V10.773a1.037 1.037 0 00-.97-1.091zm-5.252 0a1.037 1.037 0 00-.97 1.091V20.89a1.037 1.037 0 00.97 1.091 1.037 1.037 0 00.97-1.091V10.773a1.037 1.037 0 00-.97-1.091z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgDelete;
